import { ApiService } from '../../services/api_service';
import * as config from '../../wips.config.js';
import { DatenauswertungFormWrapper } from './DatenauswertungFormWrapper';
import { DatenauswertungGenerisch } from './DatenauswertungGenerisch';
import { DatenauswertungJahrauswahl } from './DatenauswertungJahrauswahl';
import { DatenauswertungReportKonfigurationBemerkungButton } from './DatenauswertungReportKonfigurationBemerkungButton';
import datenauswertungStyle from './datenauswertung.less'
import { disableKosten } from '../../helpers/showKosten';
import { fn0nZ, fn2, fn2nZ } from '../../core/formatter/formatNumber';
// import { getBrennwerteUmrechnungsfaktor } from '../../main/functions/getEmmissionsUmrechnungsfaktor';
import { getRoutingEnergiedaten } from '../../helpers/getRoutingEnergiedaten';
import { getStandorteGruppenTabRoutings } from '../dateneingabe/functions/StandorteGruppen';
import { getStyle } from './generisch/DatanauswertungGenerischStyles';
import { getValuesKWH } from './energietraeger/getValuesKWH';
import { i18n } from '../../i18n/i18n';
import { IDs } from '../../helpers/IDs';
import { isValid as isValidWaerme } from '../../main/functions/validData';
import { isVeranstaltung } from '../../helpers/getVeranstaltungen';
import { KennzahlenInfo } from './elements/KennzahlenInfo';
import { lazyInject } from '../../services/inversify';
import * as React from 'react';
import { RoutingIDs } from '../../helpers/RoutingIDs';
import { rowHasValues } from './generisch/renderRows';
import { SectionStyle } from '../../helpers/SectionStyle';
import { StandortAuswahl } from './elements/StandortAuswahl';
import { Validierung } from './elements/Validierung';
import { ValidierungHinweise } from './elements/ValidierungHinweise';
import { WActionButton } from '../../core/elements/WActionButton';
import { WHelpIcon } from '../../core/elements/WHelpIcon';


interface DatenauswertungEnergietraegerGesamtProps extends React.ClassAttributes<any> {
    data: any;
    energietraeger: string[];
    onRoutingChange: (routing: any) => void;
    routing: any;
    standortTid: number;
    standortName: string;
    jahrFirst?: number;
    jahrLast?: number;
    setJSXdirect?: (content: JSX.Element) => void;
    callbackPages?: (pageNumber: number, totalPages: number) => void;
}

interface DatenauswertungEnergietraegerGesamtState {
    pdfString?: string;
    firstJahr: number;
    lastJahr: number;
    jahrMin: number;
    jahrMax: number;
    renderButton: JSX.Element;
    validation: any;
}

export class DatenauswertungEnergietraegerGesamt extends
    React.Component<DatenauswertungEnergietraegerGesamtProps, DatenauswertungEnergietraegerGesamtState> {

    constructor(props: any) {
        super(props);
        const data: any = props.data || {};
        const startjahr: number = ((data[IDs.ENT_KONFIGURATION] || [])[0] || {}).startjahr_datenerfassung || null;
        const jahrMax: number = new Date().getFullYear();
        let jahrMin: number = (data.first_year > 2009 && data.first_year < 2015) ? data.first_year : 2015;
        jahrMin = (startjahr > jahrMin) ? startjahr : jahrMin;
        this.state = {
            lastJahr: this.props.jahrLast || jahrMax - 1,
            firstJahr: this.props.jahrFirst || jahrMin,
            jahrMin,
            jahrMax,
            renderButton: undefined,
            validation: {}
        };
    }

    @lazyInject(ApiService) private apiService: ApiService;

    private devFeaturesMap: any = config.devFeaturesMap || {};
    private disableKosten: boolean;
    private entities: any[] = [
        { titel: i18n('Wärme', 'sys'), entity: IDs.ENT_ENERGIEDATEN_WAERME }
    ];

    componentDidMount(): void {
        const energiertraeger: string = (this.props.energietraeger || []).length === 1
            ? ((this.props.data[IDs.ENT_ENERGIEDATEN_WAERME_ENERGIETRAEGER] || [])
                .find((item: any) => item.id === this.props.energietraeger[0]) || {}).name || null
            : null;
        this.disableKosten = disableKosten(this.props.data);
        this.setState({
            validation: new Validierung(
                this.props.data,
                this.props.standortTid,
                this.entities,
                'jahr',
                null,
                energiertraeger
            ).getData()
        });
    }

    getEnergietraegerEinheit(): string {
        return null; // Nur noch kWh!
        /*switch (this.props.energietraeger) {
            case 'heizoel': return 'Liter';
            case 'erdgas': return 'm3';
            case 'fluessiggas': return 'm3';
            default: return null;
        }
        */
    }

    getEnergietraegerName(id: string): string {
        switch (id) {
            case 'andere': return 'Sonstige';
            case 'bio_brennholz': return 'Brennholz';
            case 'bio_hackschnitzel': return 'Holzhackschnitzel';
            case 'bio_holzpellets': return 'Holzpellets';
            case 'biogas': return 'Biogas';
            case 'braunkohle': return 'Braunkohle';
            case 'erdgas': return 'Erdgas';
            case 'fernkaelte': return 'Fernkälte';
            case 'fernwaerme': return 'Fernwärme';
            case 'fluessiggas': return 'Flüssiggas';
            case 'heizoel': return 'Heizöl';
            case 'hel': return 'Heizöl';
            case 'steinkohle': return 'Steinkohle';
            case 'strom': return 'Strom';
            default: return id;
        }
    }

    getValues(): any {
        const data: any = this.props.data || {};
        const witterung = this.props.standortTid && this.props.data[IDs.ENT_WITTERUNGSFAKTOREN_STANDORT][this.props.standortTid]
            ? this.props.data[IDs.ENT_WITTERUNGSFAKTOREN_STANDORT][this.props.standortTid]
            : this.props.data[IDs.ENT_WITTERUNGSFAKTOREN] || {};
        // console.log(witterung);
        const rows: any[] = [];
        const diag1: any[] = [];
        const diag2: any[] = [];
        const custom_row_classes: any[] = [];
        const row_web_forced: boolean[] = [];
        const kennzahlen: any = (data[IDs.KENNZIFFERN_BERECHNET_STANDORT] || {})[this.props.standortTid]
            || data[IDs.KENNZIFFERN_BERECHNET] || {};
        const energietraeger: string[] = this.props.energietraeger || [];
        // console.log('DA Energie:', energietraeger, kennzahlen);
        for (let jahr = this.state.firstJahr; jahr <= this.state.lastJahr; jahr++) {
            let verbrauch_menge: number = 0;
            let verbrauch_kwh: number = 0;
            let verbrauch_kwh_base: number = 0;
            let kosten: number = 0;
            let co2: number = 0;
            let co2faktor: number = 0;
            let values: any;
            let heizwaerme: number = 0;
            let heizwaerme_proz: number = 0;
            let wfaktor: number = (witterung[jahr] || {}).wfaktor || 1;
            let verbrauch_wb_kwh: number = 0;
            let verbrauch_pw_kwh: number = 0;
            let verbrauch_wb_menge: number
            let preis: number;
            let renderInfoCo2 = null;
            let renderInfoKosten = null;
            let renderInfoVerbrauch = null;
            energietraeger.forEach((id: string) => {
                values = getValuesKWH(kennzahlen, data, jahr, id);
                if (values) {
                    verbrauch_menge += +values.verbrauch_menge || 0;
                    verbrauch_kwh += +values.verbrauch_kwh || 0;
                    verbrauch_kwh_base += +values.verbrauch_kwh_base || 0;
                    kosten += +values.kosten || 0;
                    heizwaerme += +values.heizwaerme || 0;
                    heizwaerme_proz = +values.heizwaerme_proz || 0;
                    co2 += +values.co2 || 0;
                    co2faktor = values.co2 > 0 && values.co2faktor;
                }
                verbrauch_wb_kwh += (values.verbrauch_kwh * wfaktor) * (heizwaerme_proz / 100);
                verbrauch_pw_kwh += (values.verbrauch_kwh) * ((100 - heizwaerme_proz) / 100);
                renderInfoCo2 = this.renderKennzahlenInfo(fn2(co2), jahr, id, 'co2');
                renderInfoKosten = this.renderKennzahlenInfo(fn2nZ(kosten), jahr, id, 'kosten');
                renderInfoVerbrauch = this.renderKennzahlenInfo(fn0nZ(verbrauch_kwh), jahr, id, 'verbrauch');
                // const heizwertfaktor = getBrennwerteUmrechnungsfaktor(id);
                // console.log('Faktor HZ', jahr, co2faktor, values, this.props.energietraeger, heizwertfaktor);
                // co2faktor = co2faktor / (heizwertfaktor ? heizwertfaktor.wert : 1);
            });
            if (energietraeger.length > 1) {
                heizwaerme_proz = (100 / verbrauch_kwh) * heizwaerme;
                renderInfoVerbrauch = this.renderKennzahlenInfo(fn0nZ(verbrauch_kwh), jahr, 'waerme_gesamt', 'verbrauch');
                renderInfoKosten = this.renderKennzahlenInfo(fn2nZ(kosten), jahr, 'waerme_gesamt', 'kosten');
                co2faktor = co2 / verbrauch_kwh_base;
                renderInfoCo2 = this.renderKennzahlenInfo(fn2(co2), jahr, 'waerme_gesamt', 'co2');
            }
            wfaktor = (!witterung || !verbrauch_kwh) ? 0 : wfaktor;
            preis = verbrauch_kwh > 0 ? kosten / verbrauch_kwh : 0;
            // Nur den Anteil der Heizwärme Witterungsbereinigen, die Prozesswärme 1:1 wieder draufrechnen (das ist der teil 100 - heizwaerme_proz)
            verbrauch_wb_menge = (verbrauch_menge * wfaktor) * (heizwaerme_proz / 100);
            const row = [
                jahr,
                fn0nZ(verbrauch_menge),
                renderInfoVerbrauch/*fn0nZ(verbrauch_kwh)*/, fn2nZ(heizwaerme_proz), fn2nZ(wfaktor), fn0nZ(verbrauch_wb_menge),
                fn0nZ(verbrauch_wb_kwh + verbrauch_pw_kwh), renderInfoKosten/*fn2nZ(kosten)*/,
                fn2nZ(preis), fn2(co2faktor * 1000000), renderInfoCo2/*fn2(co2)*/
            ];
             /*if (energietraeger !== 'fluessiggas' && energietraeger !== 'erdgas' && energietraeger !== 'heizoel') {
                row.splice(4, 1);
                row.splice(1, 1);
            }*/
            if (this.disableKosten) {
                row.splice(7, 2); // Wärmeverbrauch (Kosten) [€ (netto)]; Wärmeverbrauch (Kosten) [€/kWh]
            }
            // Additional Unit brauchen wir gar nicht mehr... also immer raus (aber drin lassen, falls sich nochmal die Anforderung ändert)
            row.splice(5, 1);
            row.splice(1, 1);
            const row_length: number = row.length;
            const hasValues: boolean = rowHasValues(row);
            const isWebForced: boolean = !!(!hasValues && this.state.validation[jahr]);
            const d1 = {
                jahr, verbrauch: verbrauch_kwh,
                ...(!this.disableKosten && { kosten: (kosten > 0) ? kosten : undefined })
            };
            const d2 = { jahr, emission: co2 };
            if (d1.kosten !== 0 && !d1.kosten) {
                delete (d1.kosten);
            }
            rows.push([
                <div data-text={row[0]}>
                    <div>{row[0]}</div>
                    {this.state.validation[jahr] &&
                        <ValidierungHinweise
                            data={this.props.data}
                            entities={this.entities}
                            id={jahr}
                            showPriorityColors
                            validation={this.state.validation}
                        />
                    }
                </div>,
                ...(!hasValues && this.state.validation[jahr]
                    ? Array.from(Array(row_length - 1), (): void => null)
                    : [...Array(row_length - 1)].map((item: any, index: number) => row[index + 1])
                )
            ]);
            if (hasValues) {
                if (verbrauch_kwh || (!this.disableKosten && kosten)) {
                    diag1.push(d1);
                }
                if (co2 || co2 === 0) {
                    diag2.push(d2);
                }
            }
            custom_row_classes.push(isWebForced ? Array.from(Array(row_length), () => 'row_field') : undefined);
            row_web_forced.push(isWebForced);
        }
        // console.log('D1', diag1);
        return { rows, diag1, diag2, custom_row_classes, row_web_forced };
    }

    render(): JSX.Element {
        const color: any = SectionStyle.getSectionColors() || {};
        const lineColor = [
            color.datenauswertung || '#4f81bd', color.zusatztools || '#f79646', color.dateneingabe || '#87bd51', '#51bd75', '#5163bd',
            '#9951bd', '#bd5175', '#bd5151'
        ];
        const additionalUnit = this.getEnergietraegerEinheit();
        let numCols = 7 + (additionalUnit !== null ? 2 : 0) + (!this.disableKosten ? 2 : 0);
        const baseWidth = 100 / numCols; // Bitte immer in Prozent angeben
        const energietraeger: string = Array.isArray(this.props.energietraeger)
            ? (this.props.energietraeger.length === 1 ? this.getEnergietraegerName(this.props.energietraeger[0]) || '' : 'Gesamt')
            : '';
        const unternehmen: string = ((this.props.data[IDs.ENT_UNTERNEHMENSDATEN] || [])[0] || {}).name
            || (this.props.data.RES_MAIN_LOAD_UNTERNEHMEN_SEL || {}).bezeichnung || null;
        const values = this.getValues();
        // const scaleFactorWitterung = additionalUnit != null ? 400 : 300;
        // const scaleFactorVerbrauch = additionalUnit != null ? 200 : 100;
        const stCl = { flex: 'unset', width: '25%' };
        const config: any = {
            titel0: unternehmen,
            titel1: `${i18n('Auswertung Wärme', 'sys')} - ${i18n(energietraeger, 'sys')}`,
            titel2: this.props.standortName,
            filename: `${i18n('Auswertung', 'sys')}_${i18n('Wärme', 'sys')}_${energietraeger}${this.state.firstJahr}_${this.state.lastJahr}.pdf`,
            report: {
                data: (this.props.data || {})[IDs.ENT_REPORT] || [], standort: +this.props.standortTid || 0, key: 'waerme',
                sub: this.props.energietraeger.length === 1 ? this.props.energietraeger[0] : 'gesamt'
            },
            baseWidth: baseWidth,
            header: {
                title: i18n('Übersicht Berechnung', 'sys'),
                blocks: [
                    {
                        label: i18n('Jahr', 'sys'),
                        width: `${baseWidth}%`
                    },
                    {
                        label: `${i18n(`Wärmeverbrauch ${energietraeger}`, 'sys')} (${i18n('Energieeinstatz', 'sys')})`,
                        width: `${baseWidth * (additionalUnit != null ? 6 : 4)}%`,
                        columns: [
                            {
                                label: ' ', label2: additionalUnit,
                                customStyleColumn: { borderLeft: '1pt solid #fff', ...stCl },
                                customStyleLabel: { width: '0%' },
                                customStyleLabel2: { borderTop: '1pt solid #fff' }
                            },
                            {
                                label: i18n('Verbrauchswert', 'sys'), label2: 'kWh',
                                customStyleColumn: { borderLeft: '1pt solid #fff', ...stCl },
                                customStyleLabel2: { borderTop: '1pt solid #fff', }
                            },
                            {
                                label: ' ', label2: `${i18n('Anteil Heizwärme', 'sys')} [%]`,
                                customStyleColumn: { ...stCl },
                                customStyleLabel: { width: '0%' },
                                customStyleLabel2: { borderTop: '1pt solid #fff' }
                            },
                            {
                                label: ' ', label2: i18n('W-Faktor', 'sys'),
                                customStyleColumn: { borderLeft: 0, ...stCl },
                                customStyleLabel: { width: '0%' },
                                customStyleLabel2: { borderTop: '1pt solid #fff', borderLeft: '1pt solid #fff' }
                            },
                            {
                                label: ' ', label2: additionalUnit,
                                customStyleColumn: { borderLeft: 0, ...stCl },
                                customStyleLabel: { width: '0%' },
                                customStyleLabel2: { borderTop: '1pt solid #fff' }
                            },
                            {
                                label: i18n('Witterungsbereinigung', 'sys'), label2: `kWh ${i18n('bereinigt', 'sys')}`,
                                customStyleColumn: { borderLeft: 0, ...stCl },
                                customStyleLabel: {
                                    right: '100%', position: 'relative',
                                    // backgroundColor: '#bccae3'
                                    // BackgroundColor spielt hier keine Rolle.
                                    // Aber komischerweise verursacht sie in PDF den Border mal 1px dünner …
                                },
                                customStyleLabel2: { borderTop: '1pt solid #fff', borderLeft: '1pt solid #fff' }
                            }
                        ]
                    },
                    {
                        label: `${i18n(`Wärmeverbrauch ${energietraeger}`, 'sys')} (${i18n('Kosten', 'sys')})`,
                        width: `${baseWidth * 2}%`,
                        columns: [
                            { label2: `€ (${i18n('netto', 'sys')})`, customStyleLabel2: { borderTop: '0pt solid #fff' } },
                            { label2: '€/kWh', customStyleLabel2: { borderTop: '0pt solid #fff' } }
                        ]
                    },
                    {
                        label: i18n('Verbrauchsbedingte CO₂-Emissionen', 'sys'),
                        width: `${baseWidth * 2}%`,
                        columns: [
                            { label2: 'gCO₂/kWh' },
                            { label2: 't' }
                        ]
                    }
                ]
            },
            rows: values.rows,
            row_classes: ['row_field_header', , 'row_field_dark', , 'row_field_dark', , , 'row_field_dark'],
            custom_row_classes: values.custom_row_classes,
            row_web_forced: values.row_web_forced,
            diagrams: [
                {
                    title: `${i18n('Verbrauch', 'sys')}${!this.disableKosten ? ` & ${i18n(`Entwicklung der ${energietraeger}kosten`, 'sys')}` : ''}`,
                    titlePdf: `${i18n('Verbrauch', 'sys')}${!this.disableKosten ? ` & ${i18n(`Entwicklung der ${energietraeger}kosten`, 'sys')}` : ''}`,
                    legend: [
                        `${i18n(`${energietraeger}verbrauch`, 'sys')} [kWh]`,
                        ...(!this.disableKosten ? [`${i18n(`${energietraeger}kosten`, 'sys')} [€]`] : [])
                    ],
                    unit: ['kWh', ...(!this.disableKosten ? ['€'] : [])],
                    X_dataKey: 'jahr',
                    Y_dataKey: ['verbrauch', ...(!this.disableKosten ? ['kosten'] : [])],
                    data: values.diag1,
                    tickPeriod: [50, ...(!this.disableKosten ? [50] : [])],
                    singleYAxis: false,
                    lineColor,
                    containerSize: { width: '90%' }
                },
                {
                    title: i18n('Verbrauchsbedingte CO₂-Emissionen', 'sys'),
                    titlePdf: i18n('Verbrauchsbedingte CO₂-Emissionen', 'sys'),
                    legend: [`${i18n('CO₂-Emissionen', 'sys')} [t]`],
                    unit: ['t'],
                    X_dataKey: 'jahr',
                    Y_dataKey: ['emission'],
                    data: values.diag2,
                    tickPeriod: [50, 50],
                    singleYAxis: true,
                    lineColor,
                    containerSize: { width: '90%' }
                }
            ]
        };
        if (this.disableKosten) {
            config.header.blocks.splice(2, 1); // Wärmeverbrauch (Kosten)
            config.row_classes.splice(7, 2);
        }
        // Spalten die wir nicht brauchen löschen
        if (additionalUnit === null) {
            config.header.blocks[1].columns.splice(4, 1);
            config.header.blocks[1].columns.splice(0, 1);
            config.row_classes.splice(5, 1);
            config.row_classes.splice(1, 1);
        }
        const helpIcon = (
            <WHelpIcon
                data={this.props.data}
                styleDivProps={{ display: 'inline-block' }}
                styleProps={{ width: 18, height: 18, borderRadius: 10, backgroundColor: '#b9cde5', verticalAlign: 'top', margin: 0 }}
                label='Datenauswertung - Hinweise'
                helpKey='datenauswertung_waerme'
                type='info'
                editBar
            />
        );

        const jahresauswahl: any = <DatenauswertungJahrauswahl
            jahrMin={this.state.jahrMin}
            jahrMax={this.state.jahrMax}
            jahrFirst={this.state.firstJahr}
            jahrLast={this.state.lastJahr}
            contextKey='datenauswertung'
            onFirstJahrChange={(jahr: number) => this.setState({ firstJahr: jahr })}
            onLastJahrChange={(jahr: number) => this.setState({ lastJahr: jahr })}
            renderClean={true}
            wrapClass={datenauswertungStyle.datenauswertungFormField}

        />;
        const arr_header_form_elements: any[] = [
            {
                elem: jahresauswahl,
                wrapClass: 'datenauswertungContentLeft',
                skipFormFieldWrapper: true
            },
            {   elem: isVeranstaltung(this.props.data, this.props.standortTid) ? this.renderVeranstaltung() : this.renderStandort(),
                wrapClass: 'datenauswertungContentGrow'
            },
            { elem: <span className={datenauswertungStyle.datenauswertungArrow}>🡆</span>, wrapClass: 'datenauswertungContentRight' },
            { elem: <><label>{i18n('Optionen', 'sys')}</label>{this.renderEingabeButton()}</>, wrapClass: 'datenauswertungContentRight' },
            { elem: <><label>&nbsp;</label>{this.renderBemerkungButton()}</>, wrapClass: 'datenauswertungContentRight' },
            { elem: <><label>&nbsp;</label>{this.state.renderButton}</>, wrapClass: 'datenauswertungContentRight' },
        ];

        return (
            <div>
                {!this.props.setJSXdirect &&
                    <div className={datenauswertungStyle.datenauswertungOuterFormContainer}>
                        {/*<DatenauswertungJahrauswahl
                            jahrMin={this.state.jahrMin}
                            jahrMax={this.state.jahrMax}
                            jahrFirst={this.state.firstJahr}
                            jahrLast={this.state.lastJahr}
                            contextKey='datenauswertung'
                            externalHeaderElements={[this.renderEingabeButton(), this.renderBemerkungButton(), this.state.renderButton]}
                            onFirstJahrChange={(jahr: number) => this.setState({ firstJahr: jahr })}
                            onLastJahrChange={(jahr: number) => this.setState({ lastJahr: jahr })}
                        />
                        <div style={{ padding: 5, paddingRight: 20 }}>{helpIcon}</div>
                        */}
                        <DatenauswertungFormWrapper
                            elements={arr_header_form_elements}
                        />
                    </div>
                }
                <DatenauswertungGenerisch
                    config={config}
                    orientation='landscape'
                    setRenderButton={(renderButton: JSX.Element) => this.setState({ renderButton })}
                    setJSXdirect={this.props.setJSXdirect}
                    callbackPages={typeof this.props.callbackPages === 'function' ? this.props.callbackPages : null}
                    pdfButtonStyle={{ backgroundColor: '#686868', color: '#fff' }}
                />
            </div>
        );
    }

    renderBemerkungButton(): JSX.Element {
        return (
            <DatenauswertungReportKonfigurationBemerkungButton
                data={this.props.data}
                standort={this.props.standortTid}
                type='waerme'
//                sub={(this.props.energietraeger || [])[0]}
                sub={this.props.energietraeger.length === 1 ? this.props.energietraeger[0] : 'gesamt'}
                // sub={this.props.energietraeger}
                styleProps={{ backgroundColor: '#686868', color: '#fff' }}
                noLabel={true}
            />
        );
    }

    renderEingabeButton(): JSX.Element {
        const data: any = this.props.data || {};
        const energietraeger: number = +((data[IDs.ENT_ENERGIEDATEN_WAERME_ENERGIETRAEGER] || [])
            .find((item: any) => item.id === (this.props.energietraeger || [])[0]) || {}).tid || null;
        return (
            <WActionButton
                label={i18n('Dateneingabe', 'sys')}
                insideText={i18n('zur E-Tool Eingabe wechseln', 'sys')}
                tooltip={i18n('zur E-Tool Eingabe wechseln', 'sys')}
                key='dateneingabe'
                action='editNote'
                styleProps={{ color: 'var(--color-button-text)', backgroundColor: 'var(--color-section-main)' }}
                onAction={() => this.props.onRoutingChange({
                    ...(getRoutingEnergiedaten(data, this.props.standortTid, [IDs.ENT_ENERGIEDATEN_WAERME], energietraeger) || {})
                })}
            />
        );
    }

    renderKennzahlenInfo(value: string, jahr: number, key: string, field: string): JSX.Element | string {
        // return !!this.devFeaturesMap.N131_KENNZAHLEN_BERECHNUNG && (this.apiService.isAdmin() || this.apiService.isBerater())
        return (
            <KennzahlenInfo
                data={this.props.data}
                data-text={value}
                id={`${key}_${field}_${jahr}`}
                key={`${key}_${field}_${jahr}`}
                keyValue={`${key}_${field}`}
                jahr={jahr}
                standort={this.props.standortTid || 'ALL'}
            />
        );
    }

    renderStandort(): JSX.Element {
        const disabled: boolean = this.props.data.MODUL_SELECTED === 'steuer';

        return (
            <StandortAuswahl
                label={i18n('Standort', 'sys')}
                data={this.props.data}
                standort={this.props.standortTid}
                disabled={disabled}
                filter={(standort: any, callback: (visible: boolean) => void) => {
                    const kennzahlen: any = (this.props.data[IDs.KENNZIFFERN_BERECHNET_STANDORT] || {})[standort.tid]
                        || this.props.data[IDs.KENNZIFFERN_BERECHNET] || {};
                    const energietraegerWaerme: any[] = this.props.data[IDs.ENT_ENERGIEDATEN_WAERME_ENERGIETRAEGER] || [];
                    const energiedaten: any[] = (this.props.data[IDs.ENT_ENERGIEDATEN_WAERME] || [])
                        .filter((item: any) => !standort.tid || (item.standort_tid_orig || null) === standort.tid)
                        .filter((element: any, index: any, array: any) => {
                            const energietraegerOK = element.energietraeger_tid_orig;
                            const monatOK = !(element.monat || 0);
                            const standortOK = (standort.tid ? (element.standort_tid_orig || null) === standort.tid : true);
                            const validOK = true || isValidWaerme(element, IDs.ENT_ENERGIEDATEN_WAERME, this.props.data);
                            return standortOK && energietraegerOK && monatOK && validOK;
                        })
                        .map((item: any) => item.energietraeger_tid_orig);
                    const energiertraeger_tid: number = +((this.props.data[IDs.ENT_ENERGIEDATEN_WAERME_ENERGIETRAEGER] || [])
                        .find((item: any) => item.id === (this.props.energietraeger || [])[0]) || {}).tid || null;
                    const flags: any = kennzahlen.flags || {};
                    const gesamt: string[] = [];
                    energietraegerWaerme.forEach((item: any) => energiedaten.indexOf(item.tid) !== -1 ? gesamt.push(item) : null);

                    if (typeof callback === 'function') {
                        callback(
                            !!flags.hasWaerme
                            && (((this.props.energietraeger || []).length > 1 && gesamt.length > 1)
                                || ((this.props.energietraeger || []).length === 1 && energiedaten.indexOf(energiertraeger_tid) !== -1)
                            )
                        );
                    }
                }}
                onStandortChange={(standort: number) => {
                    const basisRouting: any = RoutingIDs.ROUTE_DATENAUSWERTUNG_STANDORTE;
                    const basisTab: string = RoutingIDs.TABS_DATENAUSWERTUNG_STANDORTE;
                    const energiertraeger_tid: number = +((this.props.data[IDs.ENT_ENERGIEDATEN_WAERME_ENERGIETRAEGER] || [])
                        .find((item: any) => item.id === (this.props.energietraeger || [])[0]) || {}).tid || null;
                    const energietraegerWaerme: any[] = this.props.data[IDs.ENT_ENERGIEDATEN_WAERME_ENERGIETRAEGER] || [];
                    const tabRoutings: any[] = getStandorteGruppenTabRoutings(this.props.data, basisRouting, basisTab, 2);
                    const path: any = {
                        ...((tabRoutings.find((item: any) => item?.dataRow?.tid === standort) || {}).path || {}),
                        [RoutingIDs.TABS_DATENAUSWERTUNG_WAERME]: (this.props.energietraeger || []).length > 1
                            ? 0
                            : energietraegerWaerme.findIndex((item: any) => item.tid === energiertraeger_tid) + 1,
                    };
                    this.props.onRoutingChange({ path: { ...RoutingIDs.ROUTE_DATENAUSWERTUNG_WAERME, ...path } });
                }}
                renderClean
            />
        );
    }

    renderVeranstaltung(): JSX.Element {
        return <>
            <label>{i18n('Standort', 'sys')}</label>
            <input type='text' value={this.props.standortName} disabled />
        </>;
    }
}
